import React from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";

const stores = ["Store 1", "Store 2", "Store 3"];

const StoreSelector = ({
  store,
  setStore,
  open,
  onStoreClick,
  setStoreOPen,
  allStores,
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div style={{ marginTop: 10, width: "100%" }}>STORE NAME</div>
      <div
        onClick={onStoreClick}
        style={{
          marginTop: open ? 0 : 10,
          height: open ? 0 : 45,
          width: "98%",
          borderStyle: "solid",

          // borderRadius: 100,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderWidth: open ? 0 : 0.5,
          transition: "all 0.3s",
          overflow: "hidden",
          backgroundColor: BlackAndWhite.secondary,
          color: "#000000",
        }}
      >
        {store ? store.storeName : "Click here"}
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: open ? null : 0,
          overflow: "hidden",

          flexWrap: "wrap",
        }}
      >
        {allStores.map((store, index) => {
          return store.storeName !== "Store 1" ? (
            <div
              key={index}
              onClick={() => {
                setStore(store);
                setStoreOPen(false);
              }}
              style={{
                height: 40,
                width: "85%",
                borderStyle: "solid",
                margin: 5,
                // borderRadius: 8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderWidth: 0.5,
                transition: "all 0.3s",
                overflow: "hidden",
                fontSize: store ? 14 : 14,
                textAlign: "center",
                backgroundColor: BlackAndWhite.secondary,
                color: "#000000",
              }}
            >
              {store ? store.storeName : "loading"}
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
};

export default StoreSelector;
